document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-menu]');
  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-accordion]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    });
  });

  document.querySelectorAll('.product-form').forEach((form) => {
    const dialog = form.querySelector('[data-customizer-dialog]');
    if (!dialog) return;

    const textInput = dialog.querySelector('[data-custom-text-input]');
    const textInputTwo = dialog.querySelector('[data-custom-text-input-two]');
    const liveText = dialog.querySelector('[data-live-plate-text]');
    const liveTextTwo = dialog.querySelector('[data-live-plate-text-two]');
    const liveSize = dialog.querySelector('[data-live-size-label]');
    const count = dialog.querySelector('[data-character-count]');
    const countTwo = dialog.querySelector('[data-character-count-two]');
    const message = dialog.querySelector('[data-customizer-message]');
    const propertyText = form.querySelector('[data-property-text]');
    const propertyTextTwo = form.querySelector('[data-property-text-two]');
    const propertySize = form.querySelector('[data-property-size]');
    const propertyConfiguration = form.querySelector('[data-property-configuration]');
    const variantInput = form.querySelector('[data-variant-select]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const productPrice = form.querySelector('[data-product-price]');
    const summary = form.querySelector('[data-customizer-summary]');
    const variantsNode = form.querySelector('[data-product-variants]');
    const requiresSecondLine = dialog.dataset.requiresSecondLine === 'true';
    let selectedSize = dialog.dataset.defaultSize || '15CM';
    let selectedConfiguration = dialog.dataset.defaultConfiguration || 'Front & Back';
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) { variants = []; }

    const normalise = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9.]/g, '');
    const fitTextElement = (element) => {
      if (!element) return;
      element.style.fontSize = '';
      const maximum = Math.max(14, Math.floor(element.clientHeight * 0.72));
      element.style.fontSize = `${maximum}px`;
      const availableWidth = Math.max(1, element.clientWidth - 10);
      if (element.scrollWidth > availableWidth) {
        const fittedSize = Math.max(1, Math.floor(maximum * (availableWidth / element.scrollWidth)));
        element.style.fontSize = `${fittedSize}px`;
      }
    };
    const fitAllText = () => dialog.querySelectorAll('[data-live-plate-line]').forEach(fitTextElement);
    const openDialog = () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      window.setTimeout(() => { textInput?.focus(); fitAllText(); }, 50);
    };
    const closeDialog = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };
    const bindTextInput = (input, target, counter, emptyText) => {
      if (!input || !target) return;
      input.addEventListener('input', () => {
        const value = input.value.toUpperCase();
        input.value = value;
        target.textContent = value || emptyText;
        if (counter) counter.textContent = String(value.length);
        message.hidden = true;
        window.requestAnimationFrame(() => fitTextElement(target));
      });
    };

    form.querySelectorAll('[data-customizer-open]').forEach((button) => button.addEventListener('click', openDialog));
    dialog.querySelectorAll('[data-customizer-close]').forEach((button) => button.addEventListener('click', closeDialog));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
    bindTextInput(textInput, liveText, count, requiresSecondLine ? 'TOP LINE' : 'YOUR TEXT');
    bindTextInput(textInputTwo, liveTextTwo, countTwo, 'BOTTOM LINE');

    dialog.querySelectorAll('[data-custom-configuration]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedConfiguration = button.dataset.customConfiguration;
        dialog.querySelectorAll('[data-custom-configuration]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
    });

    dialog.querySelectorAll('[data-custom-size]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedSize = button.dataset.customSize;
        liveSize.textContent = `<<${selectedSize}>>`;
        dialog.querySelectorAll('[data-custom-size]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
    });

    dialog.querySelector('[data-customizer-confirm]').addEventListener('click', () => {
      const customText = textInput?.value.trim().toUpperCase() || '';
      const customTextTwo = textInputTwo?.value.trim().toUpperCase() || '';
      if (!customText || (requiresSecondLine && !customTextTwo)) {
        message.textContent = 'Please enter the text required for the plate.';
        message.hidden = false;
        (customText ? textInputTwo : textInput)?.focus();
        return;
      }

      const matchingVariant = variants.find((variant) => {
        const options = (variant.options || []).map(normalise);
        return options.includes(normalise(selectedSize)) && options.includes(normalise(selectedConfiguration));
      });
      if (!matchingVariant) {
        addButton.disabled = true;
        message.textContent = 'This size and plate option is not available.';
        message.hidden = false;
        return;
      }
      propertyText.value = customText;
      if (propertyTextTwo) propertyTextTwo.value = customTextTwo;
      propertySize.value = selectedSize;
      propertyConfiguration.value = selectedConfiguration;
      summary.querySelector('[data-summary-text]').textContent = requiresSecondLine ? `${customText} / ${customTextTwo}` : customText;
      summary.querySelector('[data-summary-size]').textContent = selectedSize;
      summary.querySelector('[data-summary-configuration]').textContent = selectedConfiguration;
      summary.hidden = false;

      if (matchingVariant && variantInput) variantInput.value = String(matchingVariant.id);
      if (matchingVariant && variantInput?.tagName === 'SELECT' && productPrice) {
        const selectedOption = Array.from(variantInput.options).find((option) => option.value === String(matchingVariant.id));
        if (selectedOption?.dataset.price) productPrice.textContent = selectedOption.dataset.price;
      }
      const available = Boolean(matchingVariant && matchingVariant.available);
      addButton.disabled = !available;
      addButton.textContent = available ? '2. Add to basket' : 'Sold out';
      closeDialog();
    });

    form.addEventListener('submit', (event) => {
      if (!propertyText.value || (requiresSecondLine && !propertyTextTwo?.value) || !propertySize.value || !propertyConfiguration.value) {
        event.preventDefault();
        openDialog();
      }
    });
    window.addEventListener('resize', fitAllText);
    if (document.fonts?.ready) document.fonts.ready.then(fitAllText);
  });
});
